import { Badge, Button, Flex, Text } from '@chakra-ui/react'
import { QRCodeCanvas } from 'qrcode.react'

import { FormModal } from '../../../components/FormModal'
import { SectionCard } from '../../../components/SectionCard'

interface IParticipantQrCodeModalProps {
  isOpen: boolean
  onClose: () => void
  token: string
  participantName: string
  eventName: string
  ticketName: string | null
}

export default function ParticipantQrCodeModal({
  isOpen,
  onClose,
  token,
  participantName,
  eventName,
  ticketName
}: IParticipantQrCodeModalProps) {
  const handleDownload = () => {
    const canvas = document.getElementById('ticket-qrcode-canvas') as HTMLCanvasElement
    if (!canvas) return
    const pngUrl = canvas.toDataURL('image/png')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `ingresso-${participantName.replace(/\s+/g, '-').toLowerCase()}.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Ingresso"
      size="compact"
      footer={
        <>
          <Button onClick={handleDownload} colorScheme="purple" borderRadius="lg" size="sm" width="full">
            Baixar QR Code
          </Button>
        </>
      }
    >
      <Text fontWeight={600} fontSize="lg">
        {participantName}
      </Text>
      <Text variant="caption" mb={4}>
        {eventName}
      </Text>
      <Flex justify="center" my={4}>
        <SectionCard variant="tile">
          <QRCodeCanvas value={token} size={220} id="ticket-qrcode-canvas" includeMargin={true} />
        </SectionCard>
      </Flex>
      {ticketName && (
        <Flex justify="center" mt={2}>
          <Badge colorScheme="purple" py={1}>
            {ticketName}
          </Badge>
        </Flex>
      )}
    </FormModal>
  )
}
